export const TaxPayerIdentificationType = {
  EmployerIdentificationNumber: 'Ein',
  SocialSecurityNumber: 'Ssn',
} as const;

export type TaxPayerIdentificationType =
  (typeof TaxPayerIdentificationType)[keyof typeof TaxPayerIdentificationType];

export const FederalTaxClassification = {
  Individual: 'Individual',
  CCorporation: 'CCorporation',
  SCorporation: 'SCorporation',
  Partnership: 'Partnership',
  TrustEstate: 'TrustEstate',
  LLCAsCCorporation: 'LLCAsCCorporation',
  LLCAsSCorporation: 'LLCAsSCorporation',
  LLCAsPartnership: 'LLCAsPartnership',
  Other: 'Other',
} as const;

export type FederalTaxClassification =
  (typeof FederalTaxClassification)[keyof typeof FederalTaxClassification];

type PartnerData = {
  id: string;
  legalName: string;
  dba: string;
  taxpayerIdentificationType: TaxPayerIdentificationType | '';
  taxpayerIdentificationNumber: string;
  federalTaxClassification: FederalTaxClassification | '';
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
};

export class Partner {
  id: string;
  legalName: string;
  dba: string;
  taxpayerIdentificationType: TaxPayerIdentificationType | '';
  taxpayerIdentificationNumber: string;
  federalTaxClassification: FederalTaxClassification | '';
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;

  constructor(data: PartnerData) {
    this.id = data.id;
    this.legalName = data.legalName;
    this.dba = data.dba;
    this.taxpayerIdentificationType = data.taxpayerIdentificationType;
    this.taxpayerIdentificationNumber = data.taxpayerIdentificationNumber;
    this.federalTaxClassification = data.federalTaxClassification;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.email = data.email;
    this.phoneNumber = data.phoneNumber;
    this.address = data.address;
    this.address2 = data.address2;
    this.city = data.city;
    this.state = data.state;
    this.zipCode = data.zipCode;
  }
}
